
const Cores = {
    neutroClaro:"#f7f7f7ff",
    principalEscuro:"#2a3f54ff",
};


export default Cores;